import { AST } from '@handlebars/parser';

export const getStatement = (statements: AST.Statement[] | null): AST.Statement | null =>
  statements?.length !== 1 ? null : statements[0];
